import "babel-polyfill"
import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n'
import store from './store'
import router from './router'
import * as VueGoogleMaps from 'vue2-google-maps'
import GlobalHelper from './libraries/GlobalHelper'

const moment = require ('moment')

let path = window.location.pathname;
let lang = 'en';
if (path.match(/^\/francais/i)) {
	lang = 'fr';
}
require( 'moment/locale/' + lang + '-ca')

Vue.use(require('vue-moment'), { moment });

Vue.config.productionTip = false

Vue.prototype.$PUBLIC_NOTICES_API = 'https://data.winnipeg.ca/resource/gnxp-9hpt.json';
Vue.prototype.$NEIGHBOURHOOD_API = 'https://data.winnipeg.ca/resource/xaux-29zr.json';
Vue.prototype.$WARDS_API = 'https://data.winnipeg.ca/resource/t4cg-yaxs.json';
//Vue.prototype.$ASSESSMENT_PARCELS_API = 'https://data.winnipeg.ca/resource/w28y-mwcf.json';
Vue.prototype.$ASSESSMENT_PARCELS_API = 'https://data.winnipeg.ca/resource/y5bg-t5e4.json';
Vue.prototype.$NOTIFICATION_API = process.env.VUE_APP_NOTIFICATION_API;
//Vue.prototype.$ASSESSMENT_API = 'https://data.winnipeg.ca/resource/d4mq-wa44.json?$order=street_name';
Vue.prototype.$ASSESSMENT_API = 'https://data.winnipeg.ca/resource/cam2-ii3u.json?$order=street_name';
Vue.prototype.$CAPTCHA_KEY = process.env.VUE_APP_CAPTCHA_KEY;

Vue.use(VueGoogleMaps, {
	load: {
		key: process.env.VUE_APP_GOOGLE_API_KEY,
		libraries: 'places', // This is required if you use the Autocomplete plugin
	},
})

Vue.mixin(GlobalHelper);

new Vue({
  i18n,
  store,
  router,
  render: h => h(App)
}).$mount('#app')
